<template>
  <router-view :doctor="$attrs.doctor" />
</template>

<script>
export default {
  watch: {
    '$route.name': function (next, prev) {
      this.fn_HIDE_PROGRESS()
    }
  }
}
</script>
